import { DocumentRequestParams } from '@lio/api-types';
import { documentQueryKey } from '@services/document/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (request: DocumentRequestParams) => client.delete(`document/${request.documentId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: documentQueryKey.search });
      queryClient.invalidateQueries({ queryKey: ['subjectivities'] });
    },
  });
  return { ...result, deleteDocumentAsync: result.mutateAsync };
};
